var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BContainer',{staticClass:"main-container",attrs:{"fluid":""}},[_c('div',{staticClass:"well"},[_c('h2',[_vm._v("These aren't the droids you're looking for")]),_c('p',[_vm._v("Sorry, can't find anything for you at this URL.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }